import {
    PuzzlePieceIcon,
    CodeBracketIcon,
    SparklesIcon,
    SquaresPlusIcon,
    AdjustmentsHorizontalIcon,
    StarIcon,
    CursorArrowRaysIcon,
    MapPinIcon,
    PhotoIcon,
    ListBulletIcon,
    CalculatorIcon,
    DocumentTextIcon,
} from '@heroicons/react/24/outline';
import type { ComponentType } from 'react';

/**
 * The icons a custom question can be given in the Add Element panel.
 *
 * A business picks a key from this list rather than supplying anything of
 *  their own - the panel is ours, and an image or markup from a definition has
 *  no business rendering in it. The same keys are listed in
 *  App\Services\CustomQuestions\CustomQuestionApi::icons().
 */
export const CUSTOM_QUESTION_ICONS: Record<string, ComponentType<any>> = {
    puzzle: PuzzlePieceIcon,
    code: CodeBracketIcon,
    sparkles: SparklesIcon,
    squares: SquaresPlusIcon,
    adjustments: AdjustmentsHorizontalIcon,
    star: StarIcon,
    cursor: CursorArrowRaysIcon,
    map: MapPinIcon,
    photo: PhotoIcon,
    list: ListBulletIcon,
    calculator: CalculatorIcon,
    document: DocumentTextIcon,
};

export const CUSTOM_QUESTION_ICON_KEYS = Object.keys(CUSTOM_QUESTION_ICONS);

export function customQuestionIcon(key?: string | null): ComponentType<any> {
    return CUSTOM_QUESTION_ICONS[key ?? ''] ?? PuzzlePieceIcon;
}
